/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'square': {
    width: 1000,
    height: 1000,
    viewBox: '0 0 1000 1000',
    data: '<path pid="0" d="M865.3 62.5H134.7c-40.1 0-72.2 32.5-72.2 72.2v730.7c0 39.7 32.1 72.2 72.2 72.2h730.7c39.7 0 72.2-32.5 72.2-72.2V134.7c-.1-39.7-32.6-72.2-72.3-72.2z"/>'
  }
})
